export default __webpack_public_path__ + "static/media/Checkmark.a2a3dc86.svg";